var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTenantIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37499 2.75C6.37499 4.06168 5.31166 5.125 3.99998 5.125C2.68831 5.125 1.62498 4.06168 1.62498 2.75C1.62498 1.43832 2.68831 0.375 3.99998 0.375C5.31166 0.375 6.37499 1.43832 6.37499 2.75Z",
    fill: "#727293"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34952 6.72452C2.05255 6.02149 3.00576 5.62606 4 5.625C4.99424 5.62606 5.94745 6.02149 6.65048 6.72452C7.35351 7.42755 7.74894 8.38076 7.75 9.375C7.75 9.4413 7.72366 9.50489 7.67678 9.55178C7.62989 9.59866 7.5663 9.625 7.5 9.625H0.5C0.433696 9.625 0.370108 9.59866 0.323223 9.55178C0.276339 9.50489 0.25 9.4413 0.25 9.375C0.251059 8.38076 0.646487 7.42755 1.34952 6.72452Z",
    fill: "#727293"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantIcon);
export default __webpack_public_path__ + "static/media/TenantIcon.49dde6b8d0ae82de8d6f0b57c674db5c.svg";
export { ForwardRef as ReactComponent };